function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useMemo, useCallback } from 'react';
import { useCookie } from '@cb/cookie-manager';
import { DEFAULT_LOGGED_OUT_CONFIG, getLocalizedURL } from '@cbhq/intl';
import { routeShouldNotBeLocalizedRegEx } from '../../../utils/locales/routesNotToLocalize.js';
import '../../../utils/useIsMobile/index.js';
import { useRouter } from '../../RouterContext.js';
import '../constants/index.js';
import DesktopBanner from './DesktopBanner.js';
import { countryMap } from './messages.js';
import MobileBanner from './MobileBanner.js';
import { jsx } from 'react/jsx-runtime';
import { COUNTRY_BANNER_COOKIE_KEY, MOBILE_BREAKPOINT } from '../constants/constants.js';
import useIsMobile from '../../../utils/useIsMobile/useIsMobile.js';
const BANNER_EXPIRATION_DAYS = 10;
function CountryBanner({
  countryFromIp = '',
  countryFromUrl = ''
}) {
  const _useCookie = useCookie(COUNTRY_BANNER_COOKIE_KEY),
    _useCookie2 = _slicedToArray(_useCookie, 2),
    isCountryBannerDismissed = _useCookie2[0],
    setCookie = _useCookie2[1];
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasMounted = _useState2[0],
    setHasMounted = _useState2[1];
  const _useState3 = useState(isCountryBannerDismissed),
    _useState4 = _slicedToArray(_useState3, 2),
    isDismissed = _useState4[0],
    setDismissed = _useState4[1];

  // Prevents banner from SSR
  useEffect(() => {
    setHasMounted(true);
  }, []);
  const _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  const isMobile = useIsMobile(MOBILE_BREAKPOINT);
  const countryFromIpConfig = DEFAULT_LOGGED_OUT_CONFIG[countryFromIp.toLowerCase()];
  const countryFromUrlConfig = DEFAULT_LOGGED_OUT_CONFIG[countryFromUrl.toLowerCase()];
  const delocalizedPath = pathname.replace(/^\/[^/]+/, '');
  const isNonLocalizedRoute = useMemo(() => !!pathname.match(routeShouldNotBeLocalizedRegEx), [pathname]);
  // We need to force en locale in order to prevent coinbase_locale cookie from redirecting subfolders
  const destination = countryFromIp?.toLowerCase() === 'us' ? `/en${delocalizedPath}` : getLocalizedURL({
    requestUrl: delocalizedPath,
    country: countryFromIp || 'us',
    acceptLanguage: typeof navigator !== 'undefined' ? navigator.language : 'en-US',
    config: DEFAULT_LOGGED_OUT_CONFIG,
    supportedLocales: countryFromIpConfig.supported_locales
  });
  const handleSetDismiss = useCallback(() => {
    setDismissed(true);
    setCookie('true', {
      expires: BANNER_EXPIRATION_DAYS
    });
  }, [setCookie]);
  if (!hasMounted || isDismissed || !countryFromIpConfig || isNonLocalizedRoute) {
    return null;
  }
  const countryNameFromUrl = countryMap[countryFromUrlConfig?.country_code?.toUpperCase()];
  const countryNameFromIp = countryMap[countryFromIpConfig?.country_code?.toUpperCase()];
  return isMobile ? /*#__PURE__*/jsx(MobileBanner, {
    countryFromIpConfig: countryFromIpConfig,
    countryNameFromUrl: countryNameFromUrl,
    countryNameFromIp: countryNameFromIp,
    destination: destination,
    onDismiss: handleSetDismiss
  }) : /*#__PURE__*/jsx(DesktopBanner, {
    countryFromIpConfig: countryFromIpConfig,
    countryNameFromUrl: countryNameFromUrl,
    countryNameFromIp: countryNameFromIp,
    destination: destination,
    onDismiss: handleSetDismiss
  });
}
export { CountryBanner as default };
//# sourceMappingURL=CountryBanner.js.map
